import { render, staticRenderFns } from "./InscripcionExamen.vue?vue&type=template&id=54d6ee8e"
import script from "./InscripcionExamen.vue?vue&type=script&lang=js"
export * from "./InscripcionExamen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports